import { useEffect, useState } from "react";
import { getDatabase, ref, get } from "firebase/database";
import {
  Package,
  MapPin,
  Home,
  Tag,
  Star,
  Scale,
  Factory,
  FileText,
  Phone,
  Mail,
  Clock,
  ClipboardList,
} from "lucide-react";
import "./userQuotations.css";

const formatDate = (timestamp) => {
  if (!timestamp) return "-";

  const date = new Date(Number(timestamp));

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const UserQuotations = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuotes = async () => {
      try {
        const db = getDatabase();
        const quoteRef = ref(db, "quoteRequest");

        console.log("Fetching:", quoteRef.toString());

        const snapshot = await get(quoteRef);

        console.log("Exists:", snapshot.exists());
        console.log("Data:", snapshot.val());

        setLoading(false);

        if (!snapshot.exists()) {
          setQuotes([]);
          return;
        }

        const data = snapshot.val();
        const list = [];

        for (const id in data) {
          if (Object.prototype.hasOwnProperty.call(data, id)) {
            list.push({
              id,
              ...data[id],
            });
          }
        }

        setQuotes(list);
      } catch (error) {
        console.error("Quote fetch error:", error);
        setQuotes([]);
        setLoading(false);
      }
    };

    fetchQuotes();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          padding: 30,
          textAlign: "center",
          fontSize: 18,
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <div style={{ padding: 25 }}>
      <h2
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          marginBottom: 8,
        }}
      >
        <ClipboardList size={24} />
        Quotation Requests
      </h2>

      <p style={{ color: "#666", marginBottom: 20 }}>
        Total Requests: <b>{quotes.length}</b>
      </p>

      {quotes.length === 0 ? (
        <h3>No quotation requests found.</h3>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fill,minmax(360px,1fr))",
            gap: 20,
          }}
        >
          {quotes.map((quote) => (
            <div
              key={quote.id}
              style={{
                background: "#fff",
                borderRadius: 14,
                padding: 20,
                border: "1px solid #e5e5e5",
                boxShadow:
                  "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 18,
                }}
              >
                <h3
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    margin: 0,
                  }}
                >
                  <Package size={19} />
                  {quote.brand || "No Brand"}
                </h3>

                <span
                  style={{
                    background: "#e8f3ff",
                    color: "#0074cc",
                    padding: "5px 12px",
                    borderRadius: 20,
                    fontSize: 13,
                  }}
                >
                  {quote.status || "Pending"}
                </span>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 14,
                }}
              >
                <Info
                  icon={<MapPin size={16} />}
                  label="City"
                  value={quote.city}
                />

                <Info
                  icon={<Home size={16} />}
                  label="Area"
                  value={quote.area}
                />

                <Info
                  icon={<Tag size={16} />}
                  label="Category"
                  value={quote.serviceCategory}
                />

                <Info
                  icon={<Star size={16} />}
                  label="Grade"
                  value={quote.grade}
                />

                <Info
                  icon={<Scale size={16} />}
                  label="Quantity"
                  value={`${quote.quantity || "-"} ${quote.unit || ""}`}
                />

                <Info
                  icon={<Factory size={16} />}
                  label="Brand"
                  value={quote.brand}
                />
              </div>

              <hr
                style={{
                  margin: "18px 0",
                  border: "0.5px solid #eee",
                }}
              />

              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <FileText size={16} />
                  <b>Requirement</b>
                </div>

                <p style={{ marginTop: 8 }}>
                  {quote.requirement || "-"}
                </p>
              </div>

              <div
                style={{
                  background: "#f7f8fa",
                  padding: 12,
                  borderRadius: 10,
                  marginTop: 15,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Phone size={16} />
                  <b>Phone:</b>
                  <span>{quote.phone || "-"}</span>
                </div>

                <div
                  style={{
                    marginTop: 10,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Mail size={16} />
                  <b>Email:</b>
                  <span>{quote.email || "-"}</span>
                </div>
              </div>

              <div
                style={{
                  marginTop: 15,
                  color: "#777",
                  fontSize: 13,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <Clock size={15} />
                Created: {formatDate(quote.createdAt)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


const Info = ({ icon, label, value }) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          marginBottom: 4,
        }}
      >
        {icon}
        <b>{label}</b>
      </div>

      <span style={{ color: "#555" }}>
        {value || "-"}
      </span>
    </div>
  );
};


export default UserQuotations;